import React, { useEffect, useRef, useState } from 'react';
import './style.css';
import { Link, useNavigate } from 'react-router-dom';
import { Award, BookOpen, CheckCircle, Clock, DollarSign, Download, Heart, Info, LogIn, LogOut, MessageSquare, Moon, PieChart, Settings, Star, Sun, User, Users } from 'react-feather';
import { useAuth, useMessage } from '../../global-components/src';
import { useTheme } from '../../global-components/src';
import { Gamepad2, LayoutGrid, Clipboard, Megaphone, History, Wallet, Bookmark, Link2, CircleDollarSign, LinkIcon, ChartNoAxesColumn, MessageCircleQuestionMark, ShieldCheck, UserCheck, BadgeCheck, LayoutDashboard, ScanFace, Vote, Sparkles } from 'lucide-react';
import { isIOSWebView, isWebView, removeToNativeiOS } from '../../utils/platform';
import { CRONOS_URL, PACOCA_URL } from '../../global-components/src/utils/vars';
import Nav from '../../global-components/src/components/navbar-right/navbar-right';
import NavbarRightLink from '../../global-components/src/components/navbar-right/navbar-right-link';
import AppsNavbarRight from '../../global-components/src/components/navbar-right/apps-link-right';
import { Icon } from '../../global-components/src/components/icon';
import { t } from 'i18next';

const NavbarRight: React.FC = () => {
    const { user } = useAuth();
    const { setMessage } = useMessage();
    const closeRef = useRef<HTMLButtonElement>(null);
    const { isSuper } = useAuth();
    const { isDarkMode } = useTheme();
    const currentMonth = new Date().getMonth();
    const isRetrospectiveSeason = currentMonth === 11 || currentMonth === 0;
 
    const copyReferralCode = () => {
        if (navigator.clipboard && navigator.clipboard.writeText && user?.referral_code) {
            navigator.clipboard.writeText(`${PACOCA_URL}/cadastro?referral_code=${user.referral_code}`)
                .then(() => setMessage("Envie para seus amigos! É necessário verificar o email", "success", "Link copiado"))
                .catch((error) => console.error('Erro ao copiar o link:', error));
        }
        closeRef.current?.click()
    }


    return (
        <>
            <Nav closeRef={closeRef}>
                {!removeToNativeiOS(user?.id) && (
                    <AppsNavbarRight/>
                )}
                
                {!removeToNativeiOS(user?.id) && (
                    <Link to="/doacao" onClick={() => closeRef.current?.click()} className="container-menu-right-item">
                        <Icon className='menu-father-icon' invertColor={!isDarkMode} name="paid" size={30}>
                            <CircleDollarSign className='menu-father-icon' size={30} opacity={.7}/> 
                        </Icon> {t("settings.donate")}
                    </Link>
                )}

                <Link to="/configuracoes" onClick={() => closeRef.current?.click()} className="container-menu-right-item">
                    <Icon className='menu-father-icon' invertColor={!isDarkMode} name="settings" size={30}>
                        <Settings className='menu-father-icon' size={30} opacity={.7}/> 
                    </Icon> {t("settings.title")}
                </Link>

                {user?.referral_code && (
                    <div onClick={copyReferralCode} className="cursor-pointer container-menu-right-item">
                        <Icon className='menu-father-icon' invertColor={!isDarkMode} name="link_2" size={30}>
                            <LinkIcon className='menu-father-icon' size={30} opacity={.7}/>
                        </Icon> {t("settings.referralCode")}
                    </div>
                )}

                {/* <Link to="/urna-votacao" onClick={() => closeRef.current?.click()} className="container-menu-right-item">
                    <Icon className='menu-father-icon' invertColor={!isDarkMode} name="leaderboard" size={30}>
                       <Vote className='menu-father-icon' size={30} opacity={.7}/>
                    </Icon> {t("election.title")}
                </Link> */}

                <Link to="/ranking" onClick={() => closeRef.current?.click()} className="container-menu-right-item">
                    <Icon className='menu-father-icon' invertColor={!isDarkMode} name="leaderboard" size={30}>
                       <ChartNoAxesColumn className='menu-father-icon' size={30} opacity={.7}/>
                    </Icon> {t("generics.ranking")}
                </Link>

                <Link to="/post/salvos" onClick={() => closeRef.current?.click()} className="container-menu-right-item">
                    <Bookmark className='menu-father-icon' size={30} opacity={.7}/>
                     {t("post.saveds")}
                </Link>
                
                <Link to="/suporte" onClick={() => closeRef.current?.click()} className="container-menu-right-item">
                    <Icon className='menu-father-icon' invertColor={!isDarkMode} name="contact_support" size={30}>
                        <MessageCircleQuestionMark className='menu-father-icon' size={30} opacity={.7}/>
                    </Icon> {t("settings.support")}
                </Link>

                {(user?.position && user?.position > 0) || isSuper() || user?.stamps?.includes('brown') ? (
                    <Link to="/moderador" onClick={() => closeRef.current?.click()} className="container-menu-right-item">
                        <Icon className='menu-father-icon' invertColor={!isDarkMode} name="admin_panel_settings" size={30}>
                           <ShieldCheck className='menu-father-icon' size={30} opacity={.7}/>
                        </Icon> {t("settings.moderator")}
                    </Link>
                ) : null} 

                {(user?.position && user?.position > 0) || isSuper() ? (
                    <Link to="/usuarios-com-selos" onClick={() => closeRef.current?.click()} className="container-menu-right-item">
                        <Icon className='menu-father-icon' invertColor={!isDarkMode} name="how_to_reg" size={30}>
                           <UserCheck className='menu-father-icon' size={30} opacity={.7}/>
                        </Icon> {t("settings.usersWithBadges")}
                    </Link>
                ) : null} 

                {!isWebView() && (
                    <Link to="/download" onClick={() => closeRef.current?.click()} className="container-menu-right-item">
                        <Icon className='menu-father-icon' invertColor={!isDarkMode} size={30}>
                            <Download className='menu-father-icon' size={27}  opacity={.7}/>
                        </Icon> {t("settings.download")}
                    </Link>
                )} 

                {isWebView() && (
                    <Link to="/versao-do-app" onClick={() => closeRef.current?.click()} className="container-menu-right-item">
                        <Icon className='menu-father-icon' invertColor={!isDarkMode} size={30}>
                            <History className='menu-father-icon' size={30} opacity={.7}/>
                        </Icon> {t("settings.version")}
                    </Link>
                )} 

                {!removeToNativeiOS(user?.id) && (
                    <Link to="/significado-selos" onClick={() => closeRef.current?.click()} className="container-menu-right-item">
                        <Icon className='menu-father-icon' invertColor={!isDarkMode} name='editor_choice' size={30}>
                            <Award className='menu-father-icon' size={30} opacity={.7}/>
                        </Icon> {t("settings.meaningSeals")}
                    </Link>
                )} 

                {!removeToNativeiOS(user?.id) && (
                    <Link to="/verificado" onClick={() => closeRef.current?.click()} className="container-menu-right-item">
                        <Icon className='menu-father-icon' invertColor={!isDarkMode} name='verified' size={30}>
                            <BadgeCheck className='menu-father-icon' size={30} opacity={.7}/>
                        </Icon> {t("settings.verified")}
                    </Link>
                )} 

                <Link to="/dashboard" onClick={() => closeRef.current?.click()} className="container-menu-right-item">
                    <Icon className='menu-father-icon' invertColor={!isDarkMode} name='dashboard' size={30}>
                        <LayoutDashboard className='menu-father-icon' size={30} opacity={.7}/>
                    </Icon> {t("settings.dashboard")}
                </Link>

                <Link to="/blog" onClick={() => closeRef.current?.click()} className="container-menu-right-item">
                    <Icon className='menu-father-icon' invertColor={!isDarkMode} name='article' size={30}>
                        <BookOpen className='menu-father-icon' size={30} opacity={.7}/>
                    </Icon> {t("settings.blog")}
                </Link>

                {/* {!removeToNativeiOS(user?.id) && (
                    <Link to="/verificado" onClick={() => closeRef.current?.click()} className="container-menu-right-item">
                        <Icon className='menu-father-icon' invertColor={!isDarkMode} name='music_cast' size={30}>
                            <Award className='menu-father-icon' size={30} opacity={.7}/>
                        </Icon> {t("settings.echoText")}
                    </Link>
                )}  */}

                {!removeToNativeiOS(user?.id) && (
                    <Link to="/anuncios" onClick={() => closeRef.current?.click()} className="container-menu-right-item">
                        <Icon className='menu-father-icon' invertColor={!isDarkMode} name='campaign' size={30}>
                            <Megaphone className='menu-father-icon' size={30} opacity={.7}/>
                        </Icon> {t("settings.advertising")}
                    </Link>
                )} 

                {!removeToNativeiOS(user?.id) && (
                    <Link to="/carteira" onClick={() => closeRef.current?.click()} className="container-menu-right-item">
                        <Icon className='menu-father-icon' invertColor={!isDarkMode} name='wallet' size={30}>
                            <Wallet className='menu-father-icon' size={30} opacity={.7}/>
                        </Icon> {t("settings.wallet")}
                    </Link>
                )} 

                {!removeToNativeiOS(user?.id) && (
                    <Link to="/molduras" onClick={() => closeRef.current?.click()} className="container-menu-right-item">
                        <Icon className='menu-father-icon' invertColor={!isDarkMode} name='ar_on_you' size={30}>
                            <ScanFace className='menu-father-icon' size={30} opacity={.7}/>
                        </Icon> {t("settings.frame")}
                    </Link>
                )} 

                {/* <span style={{ marginLeft: 5, marginTop: 2 }} className="badge bg-warning">Novo</span> */}
                {/* <span style={{ marginLeft: 5, marginTop: 2 }} className="badge bg-primary">Novo</span> */}
                {/* <span style={{ marginLeft: 5, marginTop: 2 }} className="badge bg-danger">Novo</span> */}

                {isRetrospectiveSeason && (
                    <Link to="/retrospectiva" onClick={() => closeRef.current?.click()} className="container-menu-right-item">
                        <Icon className='menu-father-icon' invertColor={!isDarkMode} name="celebration" size={30}>
                            <Sparkles className='menu-father-icon' size={30} opacity={.7}/>
                        </Icon> {t('retrospective.menuTitle')}
                    </Link>
                )}
            </Nav>
        </>
    );
};

export default NavbarRight;
